import { arrayParseDate } from '@openeducation/oe-it-services';
import {
  LevelTest,
  LevelUuid,
  LevelTestStatus,
} from '@openeducation/oe-it-shared-types';
import React, { useCallback } from 'react';
import { View } from 'react-native';

import { Loading } from '../../atoms/loading/loading';
import { CarouselBase } from '../../molecules/carousel-base/carousel-base';
import {
  LevelTestCard,
  LevelTestCardLabels,
} from '../../molecules/level-test-card/level-test-card';
import { flex, width, height, mr, margin } from '../../style-utils';

export interface LevelTestsCarouselProps {
  data: LevelTest[];
  levelNameByUuid: {
    [key in LevelUuid]: string;
  };
  isLoading?: boolean;
  labels: LevelTestCardLabels;
}

const ITEM_SPACING = 25;
const ITEM_MARGIN = 4; // NOTE: without the margin the shadow of LevelTestCard is not visible
const LEVEL_TEST_WIDTH = 160;

export const LevelTestsCarousel = ({
  data,
  isLoading,
  labels,
  levelNameByUuid,
}: LevelTestsCarouselProps) => {
  const renderItem = useCallback(
    ({ item }: { item: LevelTest }) => {
      const {
        level: { uuid },
        testType,
        testScorePercentage,
        lastUpdatedDate,
        attempt,
        status,
      } = item;

      return (
        <View style={[margin(ITEM_MARGIN)]}>
          <LevelTestCard
            levelName={levelNameByUuid[uuid]}
            testType={testType}
            scorePercentage={testScorePercentage}
            date={arrayParseDate(lastUpdatedDate)}
            attempt={attempt}
            isPassed={status === LevelTestStatus.PASSED}
            style={[mr(ITEM_SPACING - ITEM_MARGIN * 2)]}
            labels={labels}
          />
        </View>
      );
    },
    [labels, levelNameByUuid]
  );

  if (isLoading) {
    return (
      <View
        style={[
          flex('justify-content-center', 'align-items-center'),
          width('100%'),
          height(180),
        ]}
      >
        <Loading />
      </View>
    );
  }

  return (
    <CarouselBase<LevelTest>
      data={data}
      renderItem={renderItem}
      itemWidth={LEVEL_TEST_WIDTH + ITEM_SPACING}
    />
  );
};

export default LevelTestsCarousel;
